export const transformDate = (date: string, displayTime = true) => {
  const dateWithTime = date.split("T").join(", ").split(".")[0];
  return displayTime ? dateWithTime : dateWithTime.split(",")[0];
};
